// Definitions

(function() {

  if (typeof window.SITE === "undefined") {
    window.SITE = {};
  }

  SITE.timeline = function() {

    var isTimeline = document.getElementById("sobrato-timeline");
    if (isTimeline) {
      $(document).ready(function() {

        // Add smooth scrolling to all links
        $("a").on('click', function(event) {

          // Make sure this.hash has a value before overriding default behavior
          if (this.hash !== "") {
            // Prevent default anchor click behavior
            event.preventDefault();

            // Store hash
            var hash = this.hash;

            // Using jQuery's animate() method to add smooth page scroll
            // The optional number (800) specifies the number of milliseconds it takes to scroll to the specified area
            $('html, body').animate({
              scrollTop: $(hash).offset().top
            }, 800, function() {

              // Add hash (#) to URL when done scrolling (default click behavior)
              window.location.hash = hash;
            });
          } // End if
        });
      });

      var timeLineHook = document.getElementById('timelinehook');
      if (timeLineHook) {
        window.addEventListener("scroll", function() {
          var timeLineHookScrollPos = timeLineHook.getBoundingClientRect().y;
          var timelineNav = document.querySelector(".timeline__nav");

          if (timeLineHookScrollPos <= 65) {
            timelineNav.classList.remove('init');
            timelineNav.classList.remove('invisibile');
            timelineNav.classList.add('visibile')
          } else {
            timelineNav.classList.remove('visibile');
            timelineNav.classList.add('invisibile');
          }
          var timeLineChapters = document.querySelectorAll('.timeline__section');

          for (var i = 0; i < timeLineChapters.length; i++) {
            var chapter = timeLineChapters[i];
            var isActive = isScrolledIntoView(chapter)
            if (isActive) {
              var active = chapter.dataset.active;
              var matchedActive = document.querySelector(".timeline__nav__link--"+active);
              matchedActive.classList.add('active-link')
              matchedActive.classList.remove('inactive-link')
            }
            else {
              var inactive = chapter.dataset.active;
              var matchedActive = document.querySelector(".timeline__nav__link--"+inactive);
              matchedActive.classList.add('inactive-link')
                matchedActive.classList.remove('active-link')

            }
          }
        })


      }





      function isScrolledIntoView(el) {
        var rect = el.getBoundingClientRect();
        var elemTop = rect.top;
        var elemBottom = rect.bottom;

        // Only completely visible elements return true:
      isVisible = elemTop < window.innerHeight - 200 && elemBottom >= 200
        // Partially visible elements return true:
        //isVisible = elemTop < window.innerHeight && elemBottom >= 0;
        return isVisible;
      }





    }





    // var controller = new ScrollMagic.Controller();
    // var scene = new ScrollMagic.Scene({
    //   triggerElement: "#timeline"
    // })
    // .setPin("#pin-1", {pushFollowers:false,reverse:true})
    // .addTo(controller)
    // var timeline1 = new TimelineMax()
    //   .from('#slide-text', 1, {opacity:'1'})
    //   .to('#slide-text', 1, {opacity: '0'});
    //
    //
    //   new ScrollMagic.Scene ({triggerElement:"#slider-parent", reverse:true, duration: '200%'})
    //       // .setPin('.page__header__slider',{pushFollowers: true})
    //       .setTween("#slide-text", {y: "110%", ease: Linear.easeNone})
    //       .addTo(controller);
    //
    //
    // new ScrollMagic.Scene({triggerElement:"#slider-parent", reverse:true, duration: '100%'})
    //   .setTween(timeline1)
    //   .addTo(controller);


  }

})();


// Invocations

$(function() {


  SITE.timeline();

});
